var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuriname(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 26,
    viewBox: "0 0 36 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_26_3549)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_26_3549",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 30,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 30,
    height: 20,
    rx: 2,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_26_3549)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.2934 3H1V6.99866H35.2934V3Z",
    fill: "#2F742E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2934 19.0013H1V23H35.2934V19.0013Z",
    fill: "#2F742E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2934 6.99866H1V9.00134H35.2934V6.99866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2934 16.9987H1V19.0013H35.2934V16.9987Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2934 9.00134H1V17.0054H35.2934V9.00134Z",
    fill: "#C0003B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5646 16.6973L18.14 14.9357L15.7153 16.6906L16.6463 13.8439L14.2284 12.0824L17.2224 12.0891L18.1467 9.24246L19.071 12.0891H22.065L19.6403 13.8506L20.5646 16.6973Z",
    fill: "#F5CD28"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_26_3549",
    x: 0,
    y: 0,
    width: 36,
    height: 26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_26_3549"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_26_3549",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuriname);
export default __webpack_public_path__ + "static/media/Suriname.584a9579ed357938b819f111c095c323.svg";
export { ForwardRef as ReactComponent };